import { render, staticRenderFns } from "./CallOperatorTariffZoneGroup.vue?vue&type=template&id=93b5be92&"
import script from "./CallOperatorTariffZoneGroup.vue?vue&type=script&lang=ts&"
export * from "./CallOperatorTariffZoneGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports